import React from 'react';
import './MenuFooter.scss';
import Link from 'Components/Shared/Link/Link';
import WrapperLayout from 'Components/Shared/WrapperLayout/WrapperLayout';
import VerticalMenu from 'Components/MenuFooter/SubMenues/VerticalMenu';
import HorizontalMenu from 'Components/MenuFooter/SubMenues/HorizontalMenu';
import { Divider } from 'antd';

export interface ILink {
  id: string;
  displayName?: string;
  formattedName?: string;
  redirectUrl?: string;
  localPath?: string;
  iconType?: string;
  imageUrl?: string;
}

export interface IMenu {
  id?: string;
  displayName?: string;
  formattedName?: string;
  imageUrl?: string;
  items: ILink[];
}

interface IProps {
  contactMenu: IMenu;
  verticalMenues: IMenu[];
  horizontalMenues: IMenu[];
  bottomItems: ILink[];
}

const MenuFooter: React.SFC<IProps> = ({ 
  contactMenu,
  verticalMenues = [],
  horizontalMenues = [],
  bottomItems = [],
 }) => {

  const leftBottomItems = bottomItems.slice(0, bottomItems.length - 1);
  const rightBottomItem = bottomItems[bottomItems.length - 1];

  return (
    <div className='menu-footer'>
      <WrapperLayout style='top-row' justify='space-between'>
        { contactMenu && <VerticalMenu { ...contactMenu } /> }
        { verticalMenues.map(i => 
          <VerticalMenu key={ i.id } { ...i } />) 
        }
      </WrapperLayout>
      <Divider />
      <WrapperLayout style='middle-row' justify='space-around'>
        { horizontalMenues.map(i => 
          <HorizontalMenu key={ i.id } { ...i } />) 
        }
      </WrapperLayout>
      <Divider />
      <WrapperLayout style='bottom-row' justify='space-between'>
        <div className='item'>
          { leftBottomItems.map(i => 
            <Link style='text separator' key={ i.id } { ...i } />)
          }
        </div>
          <Link style='item text' { ...rightBottomItem } />
      </WrapperLayout>
    </div>
  );
};

export default MenuFooter;


// WEBPACK FOOTER //
// ./src/components/MenuFooter/MenuFooter.tsx